import { render, staticRenderFns } from "./orderReturns.vue?vue&type=template&id=aeaa2938&"
import script from "./orderReturns.vue?vue&type=script&lang=js&"
export * from "./orderReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports